import GradeCreate from "@/controllers/grade/grade-create.js";
import CONFIG from "@/assets/js/config.custom.js";
import Select2Multiple from 'v-select2-multiple-component';
import {
  required,
  maxLength
} from "vuelidate/lib/validators";

export default {
  extends: GradeCreate,
  components: {
    Select2Multiple
  },

  data() {
    return {
      inputData: {
        grade_name: null,
        division: null,
        is_final_year: false
      },
      editData: {
        grade_name: null,
        division: null,
        is_final_year: false
      },
      gradeInfo: [],
      firstname_ErrMsg: '',
      submitted: false,
    };
  },

  computed: {
    divisionOptions() {
      return Object.entries(CONFIG.DIVISION).map(([id, text]) => ({
        id: parseInt(id),
        text: text
      }));
    }
  },

  validations: {
    inputData: {
      grade_name: {
        required,
        maxLength: maxLength(50)
      },
      division: {
        required,
        validDivision: (value) => {
          if (!value) return true;
          const divisionValue = parseInt(value);
          return Object.keys(CONFIG.DIVISION)
            .map(id => parseInt(id))
            .includes(divisionValue);
        }
      }
    },
  },

  methods: {
    ...GradeCreate.methods,

    getDivisionLabel(divisionId) {
      const division = CONFIG.DIVISION[divisionId];
      return division;
    }
  }
};
